module.exports = __webpack_public_path__ + "media/src/assets/Images/HeaderPDF-45232695f8a407097199320699e4a8bb.jpg";